import React from 'react';
import PropTypes from 'prop-types';
import AddButton from "../../componentsReusable/AppTable/components/AddButton";
import appUserRoutes from "../../appUserRoutes";
import apiPlatform from "../../apiPlatform";
import AppTable from "../../componentsReusable/AppTable";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import {showModal} from "../SmsModalContainer/reducer/ModalActions";
import {showModal as showEmailModal} from "../EmailModalContainer/reducer/ModalActions";
import getWorkshop from "../../utils/getWorkshop";
import phoneNumberLabel from "../../utils/phoneNumberLabel";
import {useTranslation} from "react-i18next";
import TextWithTooltip from "../../componentsReusable/TextWithTooltip";
import workerHasPrivilege from "../../utils/workerHasPrivilege";
import {Badge} from "reactstrap";
import {isUndefined, omitBy} from "lodash";

const ClientsTable = React.forwardRef((props, ref) => {
  const { t } = useTranslation('clients_table')
  const dispatch = useDispatch();
  const [filters, setFilters] = React.useState({});

  const columns = [
    {
      dataField: 'details',
      defaultDisplayable: true,
      text: t('column.details'),
      headerStyle: {
        width: 250
      },
      formatter: (cell, row) => {
        let returnData = [];

        let person = [];
        if(row.firstname){
          person.push(row.firstname);
        }
        if(row.lastname){
          person.push(row.lastname);
        }

        row.type === 'company' ?
          returnData.push(<span key={returnData.length.toString()}>{person.length > 0 ? person.join(' ') : ''}</span>) :
          returnData.push(<span key={returnData.length.toString()}>{person.length > 0 ? person.join(' ') : <i>{t('common:no_data')}</i>}</span>)


        if(row.type === 'company'){
          let company = [];
          if(row.name){
            company.push(row.name);
          }
          if(row.nip){
            company.push(row.nip);
          }
          returnData.push(<span key={returnData.length.toString()}>{company.length > 0 ? company.join(' ') : <i>{t('common:no_data')}</i>}</span>);
        }

        return <Link to={appUserRoutes.client(row.id)} className="d-flex flex-column">
          {returnData}
        </Link>;
      }
    },
    {
      dataField: 'email',
      defaultDisplayable: true,
      text: t('column.email'),
      headerStyle: {
        width: 220
      },
      sort: true,
      formatter: (cell, row) => {
        return row.email ? <React.Fragment>
          <TextWithTooltip tag={'div'} tooltip={t('btn_send_email')} size="sm" className="text-truncate cursor-pointer" onClick={() => dispatch(showEmailModal({
            clientSelectDisabled: true,
            client: row,
            emails: [row.email],
          }))}>
            <span>{row.email}</span>
          </TextWithTooltip>
        </React.Fragment> : '';
      }
    },
    {
      dataField: 'phoneNumber.number',
      defaultDisplayable: true,
      text: t('column.phone_number'),
      headerStyle: {
        width: 140
      },
      sort: true,
      formatter: (cell, row) => {
        return row.phoneNumber.number ? <React.Fragment>
          <TextWithTooltip tag={'div'} tooltip={t('btn_send_sms')} className="text-truncate cursor-pointer" size="sm" onClick={() => dispatch(showModal({
            modalProps: {
              isOpen: true,
              clientSelectDisabled: true,
              data: {
                repairOrder: null,
                client: row.id,
                clients: [],
                phoneNumber: row.phoneNumber,
                content: '',
                sendAt: null,
              }
            }
          }))}>
            <span>{phoneNumberLabel(row.phoneNumber)}</span>
          </TextWithTooltip>
        </React.Fragment> : '';
      }
    },
    {
      dataField: 'address',
      defaultDisplayable: true,
      text: t('column.address'),
      headerStyle: {
        width: 200
      },
      formatter: (cell, row) => {
        return <div className="d-flex">
          {[row.postalCode, row.city].join(' ')}
        </div>;
      }
    },
    {
      dataField: 'workshopProductPriceGroup',
      defaultDisplayable: true,
      hidden: getWorkshop().workshopProductPriceGroups.length <= 1,
      text: t('column.product_price_group'),
      headerStyle: {
        width: 140
      },
      formatter: (cell, row) => {
        return row?.workshopProductPriceGroup ? row.workshopProductPriceGroup.name : <i className="text-muted"><small>{t('common:workshop_product_price_group_default_name')}</small></i>;
      }
    },
    {
      dataField: 'marketingAgreement',
      defaultDisplayable: false,
      text: t('column.marketing_agreement'),
      headerStyle: {
        width: 155
      },
      formatter: (cell, row) => {
        return row.marketingAgreement ? (<Badge color="success"><small>{t('common:yes')}</small></Badge>) : (<Badge color="danger"><small>{t('common:no')}</small></Badge>);
      }
    },

  ];

  return (
    <AppTable
      tableKeyName={'c'}
      ref={ref}
      searchFocused
      tableSettingsEnable
      addButton={(workerHasPrivilege('clients.create') && props.addButton) && <AddButton to={appUserRoutes.clientNew} />}
      columns={columns}
      apiFnList={apiPlatform.clients.list}
      apiFnDelete={apiPlatform.clients.delete}
      onSelectedChange={props.onSelectedChange}
      onRemoved={(workerHasPrivilege('clients.remove') && props.deleteButton) ? () => {} : undefined}
      filters={omitBy(filters, isUndefined)}
    />
  );
})

ClientsTable.defaultProps = {
  linked: true,
  addButton: true,
  deleteButton: true,
};

ClientsTable.propTypes = {
  addButton: PropTypes.bool,
  deleteButton: PropTypes.bool,
  linked: PropTypes.bool,
  onSelectedChange: PropTypes.func,
  filtersQuery: PropTypes.object,
};

export default ClientsTable;
